import React, { Component } from "react";
import moment from 'moment';
import ReactExport from "react-data-export";
import ExportPDF from "./sorted_donations_export_pdf";
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ChangeGroupButton from "./change_group_button";
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;
const changeFloat = require('../service/excelService.js').changeFloat;
const backend = require('../../config.js').backend;

const tableStyles = {
  rows: {
    style: {
      minHeight: '35px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '16px', // override the cell padding for head cells
      paddingRight: '8px',
      fontWeight: 'bold',
      fontSize: '14px'
    },
  },
  cells: {
    style: {
      paddingLeft: '16px', // override the cell padding for data cells
      paddingRight: '8px',
      fontSize: '14px'
    },
  },
};


const columns = (getReport, groups) => [
  {
    name: 'DesigID',
    selector: 'DesigID',
    cell: row => {
      if (isNaN(row.DesigID) && row.DesigID !== undefined)
        return (<div style={{ allowOverflow: true, fontWeight: 'bold', fontSize: '15px' }}>{row.DesigID}</div>)
      else return (<div>{row.DesigID}</div>)
    }
  },
  {
    name: 'Designation Name',
    selector: 'DesigName',
    grow: 2,
    cell: row => {
      if (isNaN(row.DesigID) && row.DesigID !== undefined)
        return (<div style={{ allowOverflow: true, fontWeight: 'bold', fontSize: '15px' }}>{row.DesigName}</div>)
      else return (<div>{row.DesigName}</div>)
    }
  },
  {
    name: 'Number of Donations',
    selector: 'Count',
    maxWidth: '70px'
  },
  {
    name: 'Total Donations',
    selector: 'TenderedAmount',
    right: true,
    cell: row => {
      if (row.TenderedAmount) return (<div>${numberWithCommas_display(row.TenderedAmount)}</div>)
    }
  },
  {
    name: 'Sin Admin Charges',
    selector: 'SinAdmin',
    right: true,
    cell: row => {
      if (row.SinAdmin) return (<div>${numberWithCommas_display(row.SinAdmin)}</div>)
    }
  },
  {
    name: 'Net Donations',
    selector: 'Net',
    right: true,
    cell: row => {
      if (row.Net) return (<div>${numberWithCommas_display(row.Net)}</div>)
    }
  },
  {
    name: 'Change Group',
    cell: (row) => {
      if (!isNaN(row.DesigID))
        return <ChangeGroupButton row={row} refresh={getReport} groups={groups} />
    },
    button: true,
  }
];


class Report_Sorted_Donations extends Component {

  constructor(props) {
    super(props);

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      checked: false,
      errors: {},
      loading: 'true',
      isButtonDisabled: false,
      groups: {},
      redirectLogout: false
    }

    this.getAllDonationGroups()
      .then((result) => {
        // console.log('groups', result)
        this.setState({ groups: result });
      })
  }


  handleStartDateChange(date) {

    date = moment(date).format('YYYY-MM-DD');

    this.setState({
      startDate: date
    });

  }

  handleEndDateChange(date) {

    date = moment(date).format('YYYY-MM-DD');

    this.setState({
      endDate: date
    });

  }

  inputValid = () => {
    let { startDate } = this.state;
    let { endDate } = this.state;
    let today = new Date()
    let errors = {};

    if (startDate > endDate || startDate > today) {

      errors['date'] = 'Please choose correct dates!'; this.setState({ errors: errors });
      return false;

    }
    else {
      errors = {};
      this.setState({ errors: errors });
      return true;

    }

  }


  getAllDonationGroups = _ => {

    var that = this;

    // console.log('getAllDonationGroups')
    return new Promise(function (resolve, reject) {

      fetch(backend + 'api/v1/donation/group/', {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then((data) => {
          // console.log(data);
          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else {
            resolve(data);
          }

        })

    })
  }


  getSortedDonations(startDate, endDate) {

    var that = this;

    endDate = moment(endDate).format('YYYY-MM-DD');
    startDate = moment(startDate).format('YYYY-MM-DD');

    return new Promise(function (resolve, reject) {

      var url = `api/donation/sorted/?start=` + startDate + `&end=` + endDate;

      fetch(backend + url, {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then((data) => {
          // console.log(data);

          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else {
            resolve(data);
          }
        })
        .catch((err) => {
          // console.log('getSortedDonations error', err);
          reject(err)
        })

    })
  }

  getReport = _ => {
    let { startDate } = this.state;
    let { endDate } = this.state;

    if (this.inputValid()) {

      this.setState({ checked: true });

      this.getSortedDonations(startDate, endDate)
        .then((result) => {
          this.setState({ multiData: result });
        })

    }

  }

  mergeGroupNameToData = (data, columns) => {
    // console.log(data)
    // console.log(columns)
    var table_data = [];
    var row_length = columns.length;

    var donation_grand_total = 0;
    var sinadmin_grand_total = 0;
    var net_grand_total = 0;

    for (var i = 0; i < data.length; i++) { // per group

      if (data[i].desigs) { // If this group has gift

        var groupname_row = {}
        var total_row = {}

        groupname_row[columns[0].selector] = 'Donation Group:' // the first cell of new row

        // Calculate grand total
        donation_grand_total = donation_grand_total + changeFloat(data[i].donation_total);
        sinadmin_grand_total = sinadmin_grand_total + changeFloat(data[i].sinadmin_total);
        net_grand_total = net_grand_total + changeFloat(data[i].net_total);


        for (var j = 1; j < row_length; j++) { // loop the columns to form group name row and total row

          if (j === 1) { // if it is a new group
            groupname_row[columns[j].selector] = data[i].group; // assign groupname to the second cell of new row
          }
          else {
            groupname_row[columns[j].selector] = '';
          }

          if (columns[j].selector === 'Count') { // 
            total_row[columns[j].selector] = 'Total';
          }
          if (columns[j].selector === 'TenderedAmount') { // donation total same column as tenderedAdmount
            total_row[columns[j].selector] = data[i].donation_total;
          }
          if (columns[j].selector === 'SinAdmin') {
            total_row[columns[j].selector] = data[i].sinadmin_total;
          }
          if (columns[j].selector === 'Net') {
            total_row[columns[j].selector] = data[i].net_total;
          }
        }

        table_data.push(groupname_row);
        table_data = table_data.concat(data[i].desigs);
        table_data = table_data.concat(total_row);

      }

    }

    var grand_total_row = {
      'Count': 'Grand Total',
      'Net': net_grand_total,
      'SinAdmin': sinadmin_grand_total,
      'TenderedAmount': donation_grand_total
    }

    table_data.push(grand_total_row);

    return table_data

  }

  formGroupRow = (groupData, columns, row_length) => {

    var firstCell = {};
    firstCell.value = 'Donation Group:';
    firstCell.style = {
      font: { bold: true }
    }
    var row = [firstCell];

    for (var j = 1; j < row_length; j++) { // loop the columns to form group name row and total row

      var cell;

      if (j === 1) { // if it is a new group
        cell = {
          value: groupData.group,
          style: { font: { bold: true } }
        }
        row.push(cell)
      }
      else {
        cell = { value: '' }
        row.push(cell)
      }

    }

    return row;

  }


  formTotalRow = (groupData, columns, row_length) => {

    var total_row = [];

    for (var j = 0; j < row_length; j++) { // loop the columns to form group name row and total row

      var cell;

      if (columns[j]['selector'] === 'Count') {
        // console.log(j)

        cell = {
          value: 'Total',
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' }
          }
        }

      }
      else if (columns[j]['selector'] === 'TenderedAmount' && groupData.donation_total) {

        cell = {
          value: '$' + numberWithCommas_display(groupData.donation_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' }
          }
        }

      }
      else if (columns[j]['selector'] === 'SinAdmin' && groupData.sinadmin_total) {
        cell = {
          value: '$' + numberWithCommas_display(groupData.sinadmin_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' }
          }
        }
      }
      else if (columns[j]['selector'] === 'Net' && groupData.net_total) {
        cell = {
          value: '$' + numberWithCommas_display(groupData.net_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' }
          }
        }
      }
      else {
        cell = { value: '' }
      }

      total_row.push(cell)

    }

    return total_row;

  }

  formGrandTotalRow = (grandTotal, columns, row_length) => {
    var grand_total_row = [];

    for (var j = 0; j < row_length; j++) { // loop the columns to form group name row and total row
      var cell;

      if (columns[j]['selector'] === 'Count') {

        cell = {
          value: 'Grand Total',
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' },
            border: { top: { style: 'medium', color: { rgb: '000000' } } }
          }
        }

      }
      else if (columns[j]['selector'] === 'TenderedAmount' && grandTotal.donation_grand_total) {

        cell = {
          value: '$' + numberWithCommas_display(grandTotal.donation_grand_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' },
            border: { top: { style: 'medium', color: { rgb: '000000' } } }
          }
        }

      }
      else if (columns[j]['selector'] === 'SinAdmin' && grandTotal.sinadmin_grand_total) {
        cell = {
          value: '$' + numberWithCommas_display(grandTotal.sinadmin_grand_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' },
            border: { top: { style: 'medium', color: { rgb: '000000' } } }
          }
        }
      }
      else if (columns[j]['selector'] === 'Net' && grandTotal.net_grand_total) {
        cell = {
          value: '$' + numberWithCommas_display(grandTotal.net_grand_total),
          style: {
            font: { bold: true },
            alignment: { horizontal: 'right' },
            border: { top: { style: 'medium', color: { rgb: '000000' } } }
          }
        }
      }
      else {
        cell = { value: '' }
      }

      grand_total_row.push(cell)

    }
    return grand_total_row;

  }


  formGiftRow = (giftData, columns, row_length) => {

    var group_row = []

    for (var j = 0; j < row_length; j++) { // loop the columns to form group name row and total row
      var column = columns[j]['selector']
      var type = columns[j]['type']
      var cell = {}

      if (type === 'money') {
        if (giftData[column]) {
          cell.value = '$' + numberWithCommas_display(giftData[column])
        }
        else {
          cell.value = '';
        }
        cell.style = { alignment: { horizontal: 'right' } }
      }
      else {
        cell.value = giftData[column]
      }

      group_row.push(cell)

    }

    return group_row;

  }


  excelData = (data) => {
    const excel_columns = [
      { title: 'DesigID', selector: 'DesigID', type: 'number', width: { wpx: 100 } },
      { title: 'Designation Name', type: 'string', selector: 'DesigName', width: { wpx: 300 } },
      { title: 'Number of donations', type: 'number', selector: 'Count', width: { wpx: 80 }, style: { alignment: { wrapText: true }, font: { bold: true } } },
      { title: 'Total donations', type: 'money', selector: 'TenderedAmount', width: { wpx: 130 } },
      { title: 'Total Assessments', type: 'money', selector: 'SinAdmin', width: { wpx: 130 } },
      { title: 'Net Donations', type: 'money', selector: 'Net', width: { wpx: 130 } },
    ]

    var excel_data = [];
    var row_length = excel_columns.length;

    var donation_grand_total = 0;
    var sinadmin_grand_total = 0;
    var net_grand_total = 0;

    for (var i = 0; i < data.length; i++) { // per group

      var currentGroup = data[i];

      var groupRow = this.formGroupRow(currentGroup, excel_columns, row_length)
      excel_data.push(groupRow)

      if (currentGroup.desigs) { // If this group has gifts

        var desigList = currentGroup.desigs;

        for (var k = 0; k < desigList.length; k++) { // per gift record
          var gift = desigList[k];
          var gift_row = this.formGiftRow(gift, excel_columns, row_length)
          excel_data.push(gift_row)
        }

        // Calculate grand total
        donation_grand_total = donation_grand_total + changeFloat(currentGroup.donation_total);
        sinadmin_grand_total = sinadmin_grand_total + changeFloat(currentGroup.sinadmin_total);
        net_grand_total = net_grand_total + changeFloat(currentGroup.net_total);

      }

      var totalRow = this.formTotalRow(currentGroup, excel_columns, row_length)
      excel_data.push(totalRow)

    }


    var grand_total_data = {
      donation_grand_total: donation_grand_total,
      sinadmin_grand_total: sinadmin_grand_total,
      net_grand_total: net_grand_total
    }
    var grand_total_row = this.formGrandTotalRow(grand_total_data, excel_columns, row_length)
    excel_data.push(grand_total_row);

    return [{ 'columns': excel_columns, 'data': excel_data }]

  }


  renderReport() {
    const { multiData } = this.state;
    const { groups } = this.state;

    let checked = this.state.checked;
    var filename = 'Sorted Donations_' + moment().format('YYYY-MM-DD');

    if (checked) {

      if (multiData && Object.keys(multiData).length) {
        // console.log('multiData is updated', multiData.data);

        const title = multiData.title;
        const table_data = this.mergeGroupNameToData(multiData.data, columns(this.getReport, groups))
        // console.log('after', table_data)
        const excel_data = this.excelData(multiData.data);
        // console.log(excel_data);

        const columns_ = columns(this.getReport, groups);
        multiData['columns'] = columns_;


        return (
          <div>

            <ExcelFile element={<button className="btn btn-primary">Download Excel</button>} filename={filename}>
              <ExcelSheet dataSet={excel_data} name="Report" />
            </ExcelFile>


            <ExportPDF data={multiData} />

            <DataTable
              highlightOnHover
              title={title}
              columns={columns_}
              data={table_data}
              customStyles={tableStyles}
            />

          </div>
        );
      }
      else if (multiData && Object.keys(multiData).length === 0) {
        console.log('multiData', multiData)
        return <h4 className='title'>No data returned</h4>
      }
      else {
        return (
          <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
            <h4 className='title'>Loading... This may take a while... </h4>
            <CircularProgress/>
          </div>)
      }

    }

  }


  render() {

    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    let report_table = this.renderReport();

    return (

      <div className="sorted-donation-report">
        <h3 className="title">Sorted Donations Report</h3>

        <div className="form-set row">
          <form className="form-horizontal">
            <div className="form-sets col-sm-12">
              <fieldset>
                <div className="fieldset">
                  <div className='input-dates col-sm-10'>

                    <div className="col-sm-4 input-startdate">
                      <label className="col-lg-4 control-lebel"> START DATE</label>
                      <div className='datepicker'>
                        <DatePicker
                          selected={(this.state.startDate === '') ? new Date() : new Date(this.state.startDate)}
                          onChange={this.handleStartDateChange}
                          dateFormat='dd-MM-yyyy'
                        />
                      </div>
                    </div>

                    <div className="col-sm-4 input-enddate">
                      <div className='float-right'>
                        <label className="col-lg-4 control-lebel"> END DATE</label>
                        <div className='datepicker datepicker-right'>
                          <DatePicker
                            selected={(this.state.endDate === '') ? new Date() : new Date(this.state.endDate)}
                            onChange={this.handleEndDateChange}
                            dateFormat='dd-MM-yyyy'
                          />
                        </div>
                        <span className="error">{this.state.errors["date"]}</span>
                      </div>
                    </div>

                  </div>

                  <div className="col-sm-2 check-button">
                    <button type="button" className="btn btn-primary submit" disabled={this.state.isButtonDisabled} onClick={this.getReport}>CHECK</button>
                  </div>

                </div>
              </fieldset>
            </div>
          </form>
        </div>

        <div className="report-table" id="reserve-table">
          {report_table}
        </div>

      </div>
    );

  }

}


export default Report_Sorted_Donations;
